import variables from '../variables';
// https://stackoverflow.com/questions/51519246/override-components-like-muitab-that-use-media-queries

/* eslint-disable */
const MuiListItem = {
  //  text: variables.text.primary,
  // background: variables.colors.white,
  root: {
    fontFamily: variables.font.fontFamilySerif.join(','),
    backgroundColor: variables.colors.backgroundHighlight,
    marginBottom: '16px',
    '&.Mui-selected:hover': {
      backgroundColor: 'inherit',
    },
  },
};

export default MuiListItem;
